import { render, staticRenderFns } from "./satispay-confirm.vue?vue&type=template&id=644d1884&"
import script from "./satispay-confirm.vue?vue&type=script&lang=js&"
export * from "./satispay-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports